 
export const formatTRN = (trn) => {
    if (!trn) return 'N/A';
    return String(trn).replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
  };
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-AE', {
    style: 'currency',
    currency: 'AED',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value || 0);
};
